var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78 8.584v7.003H3.065V8.584H.796V5.855h2.27V3.842c0-2.335 1.373-3.607 3.38-3.607.96 0 1.786.074 2.027.107v2.441l-1.391.001c-1.091 0-1.303.538-1.303 1.329v1.742h2.602l-.339 2.73H5.78Z",
    fill: "#fff"
  })));
};

export { SvgIconFacebook as ReactComponent };
export default __webpack_public_path__ + "c1fb5efd898a2e25a26f920f4c965d49.svg";